document.addEventListener("DOMContentLoaded", async function () {

  const blob_url = Shopify.swyft.collectionJson;
  let locale = Shopify.locale.toLowerCase();
  let location = Shopify.country.toLowerCase();
  let location_locale = `${location}-${locale}`;

  const cacheBuster = Math.floor(Math.random() * 1000000); 
  const request_url = `${blob_url}${location_locale}/${window.collection_id}.json?cb=${cacheBuster}`;
  
  try {
  
    const response = await fetch(`${request_url}`);
    const data = await response.json();

    window.swyft_collection = data.products || [];
    const event = new CustomEvent("swyftCollectionLoaded");
    window.dispatchEvent(event);
  } catch (error) {
    console.error("Error fetching collection products:", error);
  }
});